import "./Contact.module.css";
import Header from "@/reusable_sections/Header";
import LetsBuildSomethingTogether from "./sections/LetsBuildSomethingTogether";
import CommonInquiries from "./sections/CommonInquiries";
import Footer from "@/reusable_sections/Footer";
export default function ContactPage() {
  return <div>
      <Header />
      <LetsBuildSomethingTogether />
      <CommonInquiries />
      <Footer />
    </div>;
}